module.exports = __webpack_public_path__ + "media/toolkits/COVID-phones-overlay-ea0799d1.png";